module.exports = __webpack_public_path__ + "assets/img/paperwalletemptyD.afd7611a9e2057fc01564ab18b18f85b.svg";